/* Elyfit — interactions de la page d'accueil */
(function () {
  if (window.elyHomeInit) return;
  window.elyHomeInit = true;

  var root = document.documentElement;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revelation() {
    var elements = document.querySelectorAll('.ely-reveal:not(.is-visible)');
    if (reduit || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    root.classList.add('ely-anim');
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    elements.forEach(function (el) { obs.observe(el); });
  }

  function onglets(scope) {
    scope.querySelectorAll('[data-ely-onglets]').forEach(function (groupe) {
      var boutons = groupe.querySelectorAll('[role="tab"]');
      boutons.forEach(function (bouton, i) {
        bouton.addEventListener('click', function () { activer(i); });
        bouton.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var suivant = (i + (e.key === 'ArrowRight' ? 1 : boutons.length - 1)) % boutons.length;
          activer(suivant); boutons[suivant].focus();
        });
      });
      function activer(index) {
        boutons.forEach(function (b, j) {
          var actif = j === index;
          b.setAttribute('aria-selected', actif);
          b.tabIndex = actif ? 0 : -1;
          document.getElementById(b.getAttribute('aria-controls')).hidden = !actif;
        });
      }
    });
  }

  function init(scope) { revelation(); onglets(scope || document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
